import React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

import Loader from '~/components/Loader/Loader';

export default function CommunityDeleteModal({
  community,
  deleting,
  open,
  toggle,
  onConfirm,
}) {
  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader toggle={toggle}>Excluir comunidade</ModalHeader>
      <ModalBody>
        {deleting && <Loader />}
        Tem certeza que deseja excluir permanentemente a comunidade{' '}
        <strong>{community ? community.name : ''}</strong>?
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={deleting}>
          Cancelar
        </Button>
        <Button color="danger" onClick={onConfirm} disabled={deleting}>
          {deleting ? 'Excluindo...' : 'Excluir'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

